module.exports = __webpack_public_path__ + "static/git-08ec57224f5d2a9929ead8a51b22e6f8.png";